import { render, staticRenderFns } from "./CgsbcxmxEdit.vue?vue&type=template&id=6ce6e6b8&scoped=true"
import script from "./CgsbcxmxEdit.vue?vue&type=script&lang=js"
export * from "./CgsbcxmxEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce6e6b8",
  null
  
)

export default component.exports